import { PROJECTS_FILTER } from '../actions/index';

export default (state = null, action) => {
      switch(action.type){
            case PROJECTS_FILTER :
                return action.payload;
            default :
                return null;
        }
}